export const STATE_NAMES = [
    "ANDHRA PRADESH STATE",
    "ASSAM STATE",
    "CSEB STATE",
    "MANIPUR STATE",
    "TAMILNADU STATE",
    "TELANGANA STATE",
    "UTTARPRADESH STATE",
    "UTTARAKHAND STATE",
    "ARUNACHAL STATE",
    "BIHAR STATE",
    "DNH DD STATE",
    "JHARKHAND",
    "RAJASTHAN",
    "SIKKIM STATE",
    "TRIPURA STATE",
    "GEB STATE",
    "HARYANA STATE",
    "KERALA STATE",
    "MP STATE",
    "MSEB STATE",
    "MIZORAM STATE",
    "PONDICHERRY",
    "PUNJAB STATE",
    "CHANDIGARH UT",
    "DELHI",
    "GOA STATE",
    "HIMACHAL STATE",
    "JK AND LADAKH UT",
    "KARNATAKA STATE",
    "MEGHALAYA STATE",
    "NAGALAND STATE",
    "ODISHA STATE",
    "WBSETCL"
];
